/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addSuppliersToOrgApiV2MembersOrgSuppliersPost } from '../fn/members-v-2/add-suppliers-to-org-api-v-2-members-org-suppliers-post';
import { AddSuppliersToOrgApiV2MembersOrgSuppliersPost$Params } from '../fn/members-v-2/add-suppliers-to-org-api-v-2-members-org-suppliers-post';
import { addTeamMembersToOrgApiV2MembersOrgTeamPost } from '../fn/members-v-2/add-team-members-to-org-api-v-2-members-org-team-post';
import { AddTeamMembersToOrgApiV2MembersOrgTeamPost$Params } from '../fn/members-v-2/add-team-members-to-org-api-v-2-members-org-team-post';
import { BroadcastReminderEmailResponse } from '../models/broadcast-reminder-email-response';
import { broadcastSubmissionRemindersToSuppliersApiV2MembersSuppliersSubmissionsBroadcastPost } from '../fn/members-v-2/broadcast-submission-reminders-to-suppliers-api-v-2-members-suppliers-submissions-broadcast-post';
import { BroadcastSubmissionRemindersToSuppliersApiV2MembersSuppliersSubmissionsBroadcastPost$Params } from '../fn/members-v-2/broadcast-submission-reminders-to-suppliers-api-v-2-members-suppliers-submissions-broadcast-post';
import { fetchSuppliersApiV2MembersOrgSuppliersGet } from '../fn/members-v-2/fetch-suppliers-api-v-2-members-org-suppliers-get';
import { FetchSuppliersApiV2MembersOrgSuppliersGet$Params } from '../fn/members-v-2/fetch-suppliers-api-v-2-members-org-suppliers-get';
import { getAllMembersApiV2MembersAllGet } from '../fn/members-v-2/get-all-members-api-v-2-members-all-get';
import { GetAllMembersApiV2MembersAllGet$Params } from '../fn/members-v-2/get-all-members-api-v-2-members-all-get';
import { getAllOrgRecordsApiV2MembersOrgsAllGet } from '../fn/members-v-2/get-all-org-records-api-v-2-members-orgs-all-get';
import { GetAllOrgRecordsApiV2MembersOrgsAllGet$Params } from '../fn/members-v-2/get-all-org-records-api-v-2-members-orgs-all-get';
import { getListOfMembersApiV2MembersUserMeGet } from '../fn/members-v-2/get-list-of-members-api-v-2-members-user-me-get';
import { GetListOfMembersApiV2MembersUserMeGet$Params } from '../fn/members-v-2/get-list-of-members-api-v-2-members-user-me-get';
import { getMemberApiV2MembersOrgGet } from '../fn/members-v-2/get-member-api-v-2-members-org-get';
import { GetMemberApiV2MembersOrgGet$Params } from '../fn/members-v-2/get-member-api-v-2-members-org-get';
import { getTeamApiV2MembersOrgTeamsGet } from '../fn/members-v-2/get-team-api-v-2-members-org-teams-get';
import { GetTeamApiV2MembersOrgTeamsGet$Params } from '../fn/members-v-2/get-team-api-v-2-members-org-teams-get';
import { inviteSupplierApiV2MembersSupplierPost } from '../fn/members-v-2/invite-supplier-api-v-2-members-supplier-post';
import { InviteSupplierApiV2MembersSupplierPost$Params } from '../fn/members-v-2/invite-supplier-api-v-2-members-supplier-post';
import { inviteSuppliersApiV2MembersSuppliersPost } from '../fn/members-v-2/invite-suppliers-api-v-2-members-suppliers-post';
import { InviteSuppliersApiV2MembersSuppliersPost$Params } from '../fn/members-v-2/invite-suppliers-api-v-2-members-suppliers-post';
import { Members } from '../models/members';
import { MembersByUserResponse } from '../models/members-by-user-response';
import { MembersInviteSuppliers } from '../models/members-invite-suppliers';
import { MembersListAll } from '../models/members-list-all';
import { MembersSendEmailResponseSchema } from '../models/members-send-email-response-schema';
import { MembersWithoutSupplierData } from '../models/members-without-supplier-data';
import { MembersWithTeamValidation } from '../models/members-with-team-validation';
import { PageOrgsListAll } from '../models/page-orgs-list-all';
import { PageSupplierWithData } from '../models/page-supplier-with-data';
import { PageTeam } from '../models/page-team';
import { removeOrganizationApiV2MembersOrgIdDelete } from '../fn/members-v-2/remove-organization-api-v-2-members-org-id-delete';
import { RemoveOrganizationApiV2MembersOrgIdDelete$Params } from '../fn/members-v-2/remove-organization-api-v-2-members-org-id-delete';
import { removeSuppliersApiV2MembersOrgSuppliersDelete } from '../fn/members-v-2/remove-suppliers-api-v-2-members-org-suppliers-delete';
import { RemoveSuppliersApiV2MembersOrgSuppliersDelete$Params } from '../fn/members-v-2/remove-suppliers-api-v-2-members-org-suppliers-delete';
import { removeTeamMembersApiV2MembersOrgTeamsDelete } from '../fn/members-v-2/remove-team-members-api-v-2-members-org-teams-delete';
import { RemoveTeamMembersApiV2MembersOrgTeamsDelete$Params } from '../fn/members-v-2/remove-team-members-api-v-2-members-org-teams-delete';
import { sendOrganizationWelcomeEmailsApiV2MembersOrgsEmailsPost } from '../fn/members-v-2/send-organization-welcome-emails-api-v-2-members-orgs-emails-post';
import { SendOrganizationWelcomeEmailsApiV2MembersOrgsEmailsPost$Params } from '../fn/members-v-2/send-organization-welcome-emails-api-v-2-members-orgs-emails-post';
import { SupplierWithoutData } from '../models/supplier-without-data';
import { Team } from '../models/team';
import { TeamUpdateResponse } from '../models/team-update-response';
import { updateMemberInformationApiV2MembersOrgPatch } from '../fn/members-v-2/update-member-information-api-v-2-members-org-patch';
import { UpdateMemberInformationApiV2MembersOrgPatch$Params } from '../fn/members-v-2/update-member-information-api-v-2-members-org-patch';
import { updateTeamProfileApiV2MembersOrgTeamPatch } from '../fn/members-v-2/update-team-profile-api-v-2-members-org-team-patch';
import { UpdateTeamProfileApiV2MembersOrgTeamPatch$Params } from '../fn/members-v-2/update-team-profile-api-v-2-members-org-team-patch';
import { updateUpstreamOrganizationApiV2MembersOrgIdProfilePatch } from '../fn/members-v-2/update-upstream-organization-api-v-2-members-org-id-profile-patch';
import { UpdateUpstreamOrganizationApiV2MembersOrgIdProfilePatch$Params } from '../fn/members-v-2/update-upstream-organization-api-v-2-members-org-id-profile-patch';

@Injectable({ providedIn: 'root' })
export class MembersV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getListOfMembersApiV2MembersUserMeGet()` */
  static readonly GetListOfMembersApiV2MembersUserMeGetPath = '/api/v2/members/user/me';

  /**
   * Get List Of Members.
   *
   * Retrieve the list of organizations/members associated with the authenticated user.
   *
   * This endpoint gathers and returns a response containing the user's email along with a list
   * of organizations the user is associated with. Each organization record includes details such as
   * org_id, name, contact email, address, team role, full name, primary flag, secretariat member flag,
   * secretariat flag, status, and category.
   *
   * Args:
   *     auth_token (Any): The authentication token containing user information.
   *     db (Any): The secretariat's database connection (resolved via dependency).
   *
   * Returns:
   *     schemas.MembersByUserResponse: A dictionary with the user's email and associated organizations.
   *
   * Raises:
   *     HTTPException: If an error occurs during retrieval.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getListOfMembersApiV2MembersUserMeGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getListOfMembersApiV2MembersUserMeGet$Response(params?: GetListOfMembersApiV2MembersUserMeGet$Params, context?: HttpContext): Observable<StrictHttpResponse<MembersByUserResponse>> {
    return getListOfMembersApiV2MembersUserMeGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get List Of Members.
   *
   * Retrieve the list of organizations/members associated with the authenticated user.
   *
   * This endpoint gathers and returns a response containing the user's email along with a list
   * of organizations the user is associated with. Each organization record includes details such as
   * org_id, name, contact email, address, team role, full name, primary flag, secretariat member flag,
   * secretariat flag, status, and category.
   *
   * Args:
   *     auth_token (Any): The authentication token containing user information.
   *     db (Any): The secretariat's database connection (resolved via dependency).
   *
   * Returns:
   *     schemas.MembersByUserResponse: A dictionary with the user's email and associated organizations.
   *
   * Raises:
   *     HTTPException: If an error occurs during retrieval.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getListOfMembersApiV2MembersUserMeGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getListOfMembersApiV2MembersUserMeGet(params?: GetListOfMembersApiV2MembersUserMeGet$Params, context?: HttpContext): Observable<MembersByUserResponse> {
    return this.getListOfMembersApiV2MembersUserMeGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<MembersByUserResponse>): MembersByUserResponse => r.body)
    );
  }

  /** Path part for operation `getAllMembersApiV2MembersAllGet()` */
  static readonly GetAllMembersApiV2MembersAllGetPath = '/api/v2/members/all';

  /**
   * Get All Members.
   *
   * Retrieve all member records (excluding the Secretariat) with optional name filtering and censoring.
   *
   * This endpoint fetches all members from the secretariat, excluding the organization's own record
   * and optionally excluding suppliers already assigned to the organization. It also allows filtering
   * by name and censoring sensitive data like emails.
   *
   * Args:
   *     org (Any): Organization details for the secretariat member making the request.
   *     tenant (str): The secretariat identifier.
   *     name (str | None, optional): A name filter to narrow down the results.
   *     exclude_assigned_to_org (bool | None, optional): If true, excludes suppliers already assigned to the organization.
   *     include_non_members (bool | None, optional): If true, includes non-member organizations.
   *     censor_data (bool, optional): If true, censors sensitive data like email addresses.
   *
   * Returns:
   *     list[schemas.MembersListAll]: A list of member records conforming to the MembersListAll schema.
   *
   * Raises:
   *     HTTPException: If the authenticated user is not a member of the organization.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllMembersApiV2MembersAllGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllMembersApiV2MembersAllGet$Response(params: GetAllMembersApiV2MembersAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MembersListAll>>> {
    return getAllMembersApiV2MembersAllGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get All Members.
   *
   * Retrieve all member records (excluding the Secretariat) with optional name filtering and censoring.
   *
   * This endpoint fetches all members from the secretariat, excluding the organization's own record
   * and optionally excluding suppliers already assigned to the organization. It also allows filtering
   * by name and censoring sensitive data like emails.
   *
   * Args:
   *     org (Any): Organization details for the secretariat member making the request.
   *     tenant (str): The secretariat identifier.
   *     name (str | None, optional): A name filter to narrow down the results.
   *     exclude_assigned_to_org (bool | None, optional): If true, excludes suppliers already assigned to the organization.
   *     include_non_members (bool | None, optional): If true, includes non-member organizations.
   *     censor_data (bool, optional): If true, censors sensitive data like email addresses.
   *
   * Returns:
   *     list[schemas.MembersListAll]: A list of member records conforming to the MembersListAll schema.
   *
   * Raises:
   *     HTTPException: If the authenticated user is not a member of the organization.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllMembersApiV2MembersAllGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllMembersApiV2MembersAllGet(params: GetAllMembersApiV2MembersAllGet$Params, context?: HttpContext): Observable<Array<MembersListAll>> {
    return this.getAllMembersApiV2MembersAllGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<MembersListAll>>): Array<MembersListAll> => r.body)
    );
  }

  /** Path part for operation `getAllOrgRecordsApiV2MembersOrgsAllGet()` */
  static readonly GetAllOrgRecordsApiV2MembersOrgsAllGetPath = '/api/v2/members/orgs/all';

  /**
   * Get All Org Records.
   *
   * Retrieve all organization records with optional filtering.
   *
   * This endpoint fetches all organizations from the database with optional name-based
   * filtering and the ability to exclude deleted records. Each record includes transformed
   * contact_persons data containing only primary team members.
   *
   * Args:
   *     org (Any): Organization details for permission checking. Must be an Agridence admin user.
   *     name (str, optional): Filter parameter to search for members by name using regex matching.
   *     exclude_deleted (bool, optional): Whether to exclude deleted records from results. Defaults to False.
   *
   * Raises:
   *     HTTPException: 400 if the organization is not an admin internal user.
   *
   * Returns:
   *     Page[schemas.OrgsListAll]: A paginated list of member organization records with
   *         transformed contact_persons containing primary team members only.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllOrgRecordsApiV2MembersOrgsAllGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllOrgRecordsApiV2MembersOrgsAllGet$Response(params: GetAllOrgRecordsApiV2MembersOrgsAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<PageOrgsListAll>> {
    return getAllOrgRecordsApiV2MembersOrgsAllGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get All Org Records.
   *
   * Retrieve all organization records with optional filtering.
   *
   * This endpoint fetches all organizations from the database with optional name-based
   * filtering and the ability to exclude deleted records. Each record includes transformed
   * contact_persons data containing only primary team members.
   *
   * Args:
   *     org (Any): Organization details for permission checking. Must be an Agridence admin user.
   *     name (str, optional): Filter parameter to search for members by name using regex matching.
   *     exclude_deleted (bool, optional): Whether to exclude deleted records from results. Defaults to False.
   *
   * Raises:
   *     HTTPException: 400 if the organization is not an admin internal user.
   *
   * Returns:
   *     Page[schemas.OrgsListAll]: A paginated list of member organization records with
   *         transformed contact_persons containing primary team members only.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllOrgRecordsApiV2MembersOrgsAllGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllOrgRecordsApiV2MembersOrgsAllGet(params: GetAllOrgRecordsApiV2MembersOrgsAllGet$Params, context?: HttpContext): Observable<PageOrgsListAll> {
    return this.getAllOrgRecordsApiV2MembersOrgsAllGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageOrgsListAll>): PageOrgsListAll => r.body)
    );
  }

  /** Path part for operation `getMemberApiV2MembersOrgGet()` */
  static readonly GetMemberApiV2MembersOrgGetPath = '/api/v2/members/{org}';

  /**
   * Get Member.
   *
   * Retrieve a member document by organization ID.
   *
   * This endpoint returns a detailed member document for the specified organization,
   * including supplier information if available.
   *
   * Args:
   *     org (Any): The organization details associated with the secretariat.
   *
   * Returns:
   *     Union[schemas.Members, dict]: A member document conforming to the Members schema or an empty dictionary if not found.
   *
   * Raises:
   *     HTTPException: If the authenticated user is not a member of the organization.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMemberApiV2MembersOrgGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMemberApiV2MembersOrgGet$Response(params: GetMemberApiV2MembersOrgGet$Params, context?: HttpContext): Observable<StrictHttpResponse<(Members | {
})>> {
    return getMemberApiV2MembersOrgGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Member.
   *
   * Retrieve a member document by organization ID.
   *
   * This endpoint returns a detailed member document for the specified organization,
   * including supplier information if available.
   *
   * Args:
   *     org (Any): The organization details associated with the secretariat.
   *
   * Returns:
   *     Union[schemas.Members, dict]: A member document conforming to the Members schema or an empty dictionary if not found.
   *
   * Raises:
   *     HTTPException: If the authenticated user is not a member of the organization.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMemberApiV2MembersOrgGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMemberApiV2MembersOrgGet(params: GetMemberApiV2MembersOrgGet$Params, context?: HttpContext): Observable<(Members | {
})> {
    return this.getMemberApiV2MembersOrgGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<(Members | {
})>): (Members | {
}) => r.body)
    );
  }

  /** Path part for operation `updateMemberInformationApiV2MembersOrgPatch()` */
  static readonly UpdateMemberInformationApiV2MembersOrgPatchPath = '/api/v2/members/{org}';

  /**
   * Update Member Information.
   *
   * Update the general information of a member/organization.
   *
   * This endpoint updates a member's general information using the provided update data.
   * It verifies that the authenticated user is part of the organization before making changes.
   *
   * Args:
   *     update_data (schemas.MembersInformationUpdate): The update data for the member/organization.
   *     org (Any): Organization details for the member to be updated.
   *
   * Returns:
   *     schemas.MembersWithoutSupplierData: The updated member document excluding supplier-specific data.
   *
   * Raises:
   *     HTTPException: If the authenticated user is not a member of the organization or if the member record is not found.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateMemberInformationApiV2MembersOrgPatch()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateMemberInformationApiV2MembersOrgPatch$Response(params: UpdateMemberInformationApiV2MembersOrgPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<MembersWithoutSupplierData>> {
    return updateMemberInformationApiV2MembersOrgPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Member Information.
   *
   * Update the general information of a member/organization.
   *
   * This endpoint updates a member's general information using the provided update data.
   * It verifies that the authenticated user is part of the organization before making changes.
   *
   * Args:
   *     update_data (schemas.MembersInformationUpdate): The update data for the member/organization.
   *     org (Any): Organization details for the member to be updated.
   *
   * Returns:
   *     schemas.MembersWithoutSupplierData: The updated member document excluding supplier-specific data.
   *
   * Raises:
   *     HTTPException: If the authenticated user is not a member of the organization or if the member record is not found.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateMemberInformationApiV2MembersOrgPatch$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateMemberInformationApiV2MembersOrgPatch(params: UpdateMemberInformationApiV2MembersOrgPatch$Params, context?: HttpContext): Observable<MembersWithoutSupplierData> {
    return this.updateMemberInformationApiV2MembersOrgPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<MembersWithoutSupplierData>): MembersWithoutSupplierData => r.body)
    );
  }

  /** Path part for operation `getTeamApiV2MembersOrgTeamsGet()` */
  static readonly GetTeamApiV2MembersOrgTeamsGetPath = '/api/v2/members/{org}/teams';

  /**
   * Get Team.
   *
   * Retrieve a paginated list of team members for a specified organization.
   *
   * This endpoint returns the team members associated with the organization. An optional
   * name filter can be applied, and the requesting user's own entry can be excluded if desired.
   *
   * Args:
   *     auth_token (Any): The authentication token containing the user's email.
   *     org (Any): Organization details for which the team data is requested.
   *     excludeSelf (bool, optional): Flag to exclude the requesting user's email from the results.
   *     name (str | None, optional): A name filter to search for specific team members.
   *
   * Returns:
   *     Page[schemas.Team]: A paginated list of team members as per the Team schema.
   *
   * Raises:
   *     HTTPException: If the authenticated user is not a member of the organization or if the organization does not exist.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTeamApiV2MembersOrgTeamsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTeamApiV2MembersOrgTeamsGet$Response(params: GetTeamApiV2MembersOrgTeamsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<PageTeam>> {
    return getTeamApiV2MembersOrgTeamsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Team.
   *
   * Retrieve a paginated list of team members for a specified organization.
   *
   * This endpoint returns the team members associated with the organization. An optional
   * name filter can be applied, and the requesting user's own entry can be excluded if desired.
   *
   * Args:
   *     auth_token (Any): The authentication token containing the user's email.
   *     org (Any): Organization details for which the team data is requested.
   *     excludeSelf (bool, optional): Flag to exclude the requesting user's email from the results.
   *     name (str | None, optional): A name filter to search for specific team members.
   *
   * Returns:
   *     Page[schemas.Team]: A paginated list of team members as per the Team schema.
   *
   * Raises:
   *     HTTPException: If the authenticated user is not a member of the organization or if the organization does not exist.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTeamApiV2MembersOrgTeamsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTeamApiV2MembersOrgTeamsGet(params: GetTeamApiV2MembersOrgTeamsGet$Params, context?: HttpContext): Observable<PageTeam> {
    return this.getTeamApiV2MembersOrgTeamsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageTeam>): PageTeam => r.body)
    );
  }

  /** Path part for operation `removeTeamMembersApiV2MembersOrgTeamsDelete()` */
  static readonly RemoveTeamMembersApiV2MembersOrgTeamsDeletePath = '/api/v2/members/{org}/teams';

  /**
   * Remove Team Members.
   *
   * Remove specified team members from an organization.
   *
   * This endpoint removes team members (by email) from the organization's team list.
   * It updates the team list by filtering out the specified members.
   *
   * Args:
   *     org (Any): Organization details from which team members are to be removed.
   *     team_in (schemas.TeamMembersToRemove): Data specifying the list of team member emails to remove.
   *
   * Returns:
   *     list[schemas.Team]: The updated list of team members.
   *
   * Raises:
   *     HTTPException: If the authenticated user is not a member of the organization or if no matching team members are found.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeTeamMembersApiV2MembersOrgTeamsDelete()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  removeTeamMembersApiV2MembersOrgTeamsDelete$Response(params: RemoveTeamMembersApiV2MembersOrgTeamsDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Team>>> {
    return removeTeamMembersApiV2MembersOrgTeamsDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Remove Team Members.
   *
   * Remove specified team members from an organization.
   *
   * This endpoint removes team members (by email) from the organization's team list.
   * It updates the team list by filtering out the specified members.
   *
   * Args:
   *     org (Any): Organization details from which team members are to be removed.
   *     team_in (schemas.TeamMembersToRemove): Data specifying the list of team member emails to remove.
   *
   * Returns:
   *     list[schemas.Team]: The updated list of team members.
   *
   * Raises:
   *     HTTPException: If the authenticated user is not a member of the organization or if no matching team members are found.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeTeamMembersApiV2MembersOrgTeamsDelete$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  removeTeamMembersApiV2MembersOrgTeamsDelete(params: RemoveTeamMembersApiV2MembersOrgTeamsDelete$Params, context?: HttpContext): Observable<Array<Team>> {
    return this.removeTeamMembersApiV2MembersOrgTeamsDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Team>>): Array<Team> => r.body)
    );
  }

  /** Path part for operation `fetchSuppliersApiV2MembersOrgSuppliersGet()` */
  static readonly FetchSuppliersApiV2MembersOrgSuppliersGetPath = '/api/v2/members/{org}/suppliers';

  /**
   * Fetch Suppliers.
   *
   * Retrieve a paginated list of suppliers for a member by organization ID.
   *
   * This endpoint fetches supplier information associated with the given organization.
   * If the organization is the secretariat and flagged accordingly, it retrieves all members
   * (excluding the secretariat) as potential suppliers. An optional name filter can be applied.
   * Sensitive data like emails and names can be censored by setting censor_data=true.
   *
   * Args:
   *     org (Any): Organization details from which supplier data is requested.
   *     name (str | None, optional): A name filter to search suppliers by name.
   *     tenant (str): The secretariat tenant.
   *     censor_data (bool, optional): Whether to censor sensitive data like emails and names. Defaults to False.
   *
   * Returns:
   *     Page[schemas.SupplierWithData]: A paginated list of supplier data.
   *
   * Raises:
   *     HTTPException: If the authenticated user is not a member of the organization.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fetchSuppliersApiV2MembersOrgSuppliersGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  fetchSuppliersApiV2MembersOrgSuppliersGet$Response(params: FetchSuppliersApiV2MembersOrgSuppliersGet$Params, context?: HttpContext): Observable<StrictHttpResponse<PageSupplierWithData>> {
    return fetchSuppliersApiV2MembersOrgSuppliersGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Fetch Suppliers.
   *
   * Retrieve a paginated list of suppliers for a member by organization ID.
   *
   * This endpoint fetches supplier information associated with the given organization.
   * If the organization is the secretariat and flagged accordingly, it retrieves all members
   * (excluding the secretariat) as potential suppliers. An optional name filter can be applied.
   * Sensitive data like emails and names can be censored by setting censor_data=true.
   *
   * Args:
   *     org (Any): Organization details from which supplier data is requested.
   *     name (str | None, optional): A name filter to search suppliers by name.
   *     tenant (str): The secretariat tenant.
   *     censor_data (bool, optional): Whether to censor sensitive data like emails and names. Defaults to False.
   *
   * Returns:
   *     Page[schemas.SupplierWithData]: A paginated list of supplier data.
   *
   * Raises:
   *     HTTPException: If the authenticated user is not a member of the organization.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `fetchSuppliersApiV2MembersOrgSuppliersGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fetchSuppliersApiV2MembersOrgSuppliersGet(params: FetchSuppliersApiV2MembersOrgSuppliersGet$Params, context?: HttpContext): Observable<PageSupplierWithData> {
    return this.fetchSuppliersApiV2MembersOrgSuppliersGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageSupplierWithData>): PageSupplierWithData => r.body)
    );
  }

  /** Path part for operation `addSuppliersToOrgApiV2MembersOrgSuppliersPost()` */
  static readonly AddSuppliersToOrgApiV2MembersOrgSuppliersPostPath = '/api/v2/members/{org}/suppliers';

  /**
   * Add Suppliers To Org.
   *
   * Add existing suppliers to an organization.
   *
   * This endpoint adds suppliers (by their organization IDs) to the current organization's supplier list.
   * It validates that each supplier exists and is not already associated with the organization,
   * then updates the supplier list and sends email notifications asynchronously.
   *
   * Args:
   *     supplier_in (list[str]): A list of supplier organization IDs.
   *     auth_token (Any): The authentication token containing the user's email.
   *     tenant (str): The secretariat identifier.
   *     org (Any): Organization details to which suppliers are being added.
   *     background_tasks (BackgroundTasks): A background task handler for sending email notifications.
   *
   * Returns:
   *     list[schemas.SupplierWithoutData]: The updated list of suppliers.
   *
   * Raises:
   *     HTTPException: If the authenticated user is not a member of the organization or if a supplier is already added.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addSuppliersToOrgApiV2MembersOrgSuppliersPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addSuppliersToOrgApiV2MembersOrgSuppliersPost$Response(params: AddSuppliersToOrgApiV2MembersOrgSuppliersPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SupplierWithoutData>>> {
    return addSuppliersToOrgApiV2MembersOrgSuppliersPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Add Suppliers To Org.
   *
   * Add existing suppliers to an organization.
   *
   * This endpoint adds suppliers (by their organization IDs) to the current organization's supplier list.
   * It validates that each supplier exists and is not already associated with the organization,
   * then updates the supplier list and sends email notifications asynchronously.
   *
   * Args:
   *     supplier_in (list[str]): A list of supplier organization IDs.
   *     auth_token (Any): The authentication token containing the user's email.
   *     tenant (str): The secretariat identifier.
   *     org (Any): Organization details to which suppliers are being added.
   *     background_tasks (BackgroundTasks): A background task handler for sending email notifications.
   *
   * Returns:
   *     list[schemas.SupplierWithoutData]: The updated list of suppliers.
   *
   * Raises:
   *     HTTPException: If the authenticated user is not a member of the organization or if a supplier is already added.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addSuppliersToOrgApiV2MembersOrgSuppliersPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addSuppliersToOrgApiV2MembersOrgSuppliersPost(params: AddSuppliersToOrgApiV2MembersOrgSuppliersPost$Params, context?: HttpContext): Observable<Array<SupplierWithoutData>> {
    return this.addSuppliersToOrgApiV2MembersOrgSuppliersPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SupplierWithoutData>>): Array<SupplierWithoutData> => r.body)
    );
  }

  /** Path part for operation `removeSuppliersApiV2MembersOrgSuppliersDelete()` */
  static readonly RemoveSuppliersApiV2MembersOrgSuppliersDeletePath = '/api/v2/members/{org}/suppliers';

  /**
   * Remove Suppliers.
   *
   * Remove specified suppliers from an organization.
   *
   * This endpoint removes supplier entries (identified by organization IDs) from the organization's supplier list.
   * It verifies that at least one of the suppliers to be removed exists in the current list before updating.
   *
   * Args:
   *     org (Any): Organization details from which suppliers are to be removed.
   *     suppliers_in (schemas.SuppliersToRemove): Data specifying the list of supplier IDs to remove.
   *
   * Returns:
   *     list[schemas.SupplierWithoutData]: The updated list of suppliers.
   *
   * Raises:
   *     HTTPException: If the authenticated user is not a member of the organization or if no matching suppliers are found.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeSuppliersApiV2MembersOrgSuppliersDelete()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  removeSuppliersApiV2MembersOrgSuppliersDelete$Response(params: RemoveSuppliersApiV2MembersOrgSuppliersDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SupplierWithoutData>>> {
    return removeSuppliersApiV2MembersOrgSuppliersDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Remove Suppliers.
   *
   * Remove specified suppliers from an organization.
   *
   * This endpoint removes supplier entries (identified by organization IDs) from the organization's supplier list.
   * It verifies that at least one of the suppliers to be removed exists in the current list before updating.
   *
   * Args:
   *     org (Any): Organization details from which suppliers are to be removed.
   *     suppliers_in (schemas.SuppliersToRemove): Data specifying the list of supplier IDs to remove.
   *
   * Returns:
   *     list[schemas.SupplierWithoutData]: The updated list of suppliers.
   *
   * Raises:
   *     HTTPException: If the authenticated user is not a member of the organization or if no matching suppliers are found.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeSuppliersApiV2MembersOrgSuppliersDelete$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  removeSuppliersApiV2MembersOrgSuppliersDelete(params: RemoveSuppliersApiV2MembersOrgSuppliersDelete$Params, context?: HttpContext): Observable<Array<SupplierWithoutData>> {
    return this.removeSuppliersApiV2MembersOrgSuppliersDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SupplierWithoutData>>): Array<SupplierWithoutData> => r.body)
    );
  }

  /** Path part for operation `addTeamMembersToOrgApiV2MembersOrgTeamPost()` */
  static readonly AddTeamMembersToOrgApiV2MembersOrgTeamPostPath = '/api/v2/members/{org}/team';

  /**
   * Add Team Members To Org.
   *
   * Add new team members to an organization.
   *
   * This endpoint allows adding one or more team members to the specified organization.
   * It validates that each new team member's email is not already present in the organization's team,
   * updates the team accordingly, and sends an invitation email asynchronously.
   *
   * Args:
   *     team_in (list[schemas.Team]): A list of team member data to be added.
   *     org (Any): Organization details to which team members are being added.
   *     background_tasks (BackgroundTasks): A background task handler for sending emails.
   *
   * Returns:
   *     list[schemas.Team]: The updated list of team members.
   *
   * Raises:
   *     HTTPException: If the authenticated user is not a member of the organization or if a team member's email already exists.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addTeamMembersToOrgApiV2MembersOrgTeamPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addTeamMembersToOrgApiV2MembersOrgTeamPost$Response(params: AddTeamMembersToOrgApiV2MembersOrgTeamPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Team>>> {
    return addTeamMembersToOrgApiV2MembersOrgTeamPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Add Team Members To Org.
   *
   * Add new team members to an organization.
   *
   * This endpoint allows adding one or more team members to the specified organization.
   * It validates that each new team member's email is not already present in the organization's team,
   * updates the team accordingly, and sends an invitation email asynchronously.
   *
   * Args:
   *     team_in (list[schemas.Team]): A list of team member data to be added.
   *     org (Any): Organization details to which team members are being added.
   *     background_tasks (BackgroundTasks): A background task handler for sending emails.
   *
   * Returns:
   *     list[schemas.Team]: The updated list of team members.
   *
   * Raises:
   *     HTTPException: If the authenticated user is not a member of the organization or if a team member's email already exists.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addTeamMembersToOrgApiV2MembersOrgTeamPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addTeamMembersToOrgApiV2MembersOrgTeamPost(params: AddTeamMembersToOrgApiV2MembersOrgTeamPost$Params, context?: HttpContext): Observable<Array<Team>> {
    return this.addTeamMembersToOrgApiV2MembersOrgTeamPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Team>>): Array<Team> => r.body)
    );
  }

  /** Path part for operation `updateTeamProfileApiV2MembersOrgTeamPatch()` */
  static readonly UpdateTeamProfileApiV2MembersOrgTeamPatchPath = '/api/v2/members/{org}/team';

  /**
   * Update Team Profile.
   *
   * Update a team member's profile within an organization.
   *
   * This endpoint updates the profile details of a team member (identified by email) within the specified organization.
   * It ensures that the team member exists before applying the updates. Email updates are restricted to Agridence organizations only.
   * When both email and org_id are provided, the operation can update a team member across organizations.
   *
   * Args:
   *     update_data (schemas.TeamUpdate): The update data for the team member. If org_id is provided along with email,
   *         the update will target the specified organization instead of the path organization.
   *     org (Any): Organization details where the requesting user resides (used for permission validation).
   *
   * Returns:
   *     list[schemas.TeamUpdateResponse]: A list containing the updated team member's information.
   *
   * Raises:
   *     HTTPException: If the authenticated user is not a member of the organization, if the team member is not found,
   *                   or if email update is attempted by a non-Agridence organization.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTeamProfileApiV2MembersOrgTeamPatch()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTeamProfileApiV2MembersOrgTeamPatch$Response(params: UpdateTeamProfileApiV2MembersOrgTeamPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TeamUpdateResponse>>> {
    return updateTeamProfileApiV2MembersOrgTeamPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Team Profile.
   *
   * Update a team member's profile within an organization.
   *
   * This endpoint updates the profile details of a team member (identified by email) within the specified organization.
   * It ensures that the team member exists before applying the updates. Email updates are restricted to Agridence organizations only.
   * When both email and org_id are provided, the operation can update a team member across organizations.
   *
   * Args:
   *     update_data (schemas.TeamUpdate): The update data for the team member. If org_id is provided along with email,
   *         the update will target the specified organization instead of the path organization.
   *     org (Any): Organization details where the requesting user resides (used for permission validation).
   *
   * Returns:
   *     list[schemas.TeamUpdateResponse]: A list containing the updated team member's information.
   *
   * Raises:
   *     HTTPException: If the authenticated user is not a member of the organization, if the team member is not found,
   *                   or if email update is attempted by a non-Agridence organization.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateTeamProfileApiV2MembersOrgTeamPatch$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTeamProfileApiV2MembersOrgTeamPatch(params: UpdateTeamProfileApiV2MembersOrgTeamPatch$Params, context?: HttpContext): Observable<Array<TeamUpdateResponse>> {
    return this.updateTeamProfileApiV2MembersOrgTeamPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TeamUpdateResponse>>): Array<TeamUpdateResponse> => r.body)
    );
  }

  /** Path part for operation `inviteSupplierApiV2MembersSupplierPost()` */
  static readonly InviteSupplierApiV2MembersSupplierPostPath = '/api/v2/members/supplier';

  /**
   * Invite Supplier.
   *
   * Invite a new supplier via email.
   *
   * This endpoint creates a new member document for a supplier invite,
   * initializes default attributes, and sends an invitation email asynchronously.
   *
   * Args:
   *     member_in (schemas.MembersCreateFromEmailInvite): The supplier invitation data.
   *     auth_token (Any): The authentication token containing the user's email.
   *     org (Any): Organization details for the secretariat member issuing the invite.
   *     background_tasks (BackgroundTasks): A background task handler for sending emails.
   *
   * Returns:
   *     schemas.MembersWithoutSupplierData: The created supplier member document without supplier-specific data.
   *
   * Raises:
   *     HTTPException: If the authenticated user is not a member of the organization.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inviteSupplierApiV2MembersSupplierPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inviteSupplierApiV2MembersSupplierPost$Response(params: InviteSupplierApiV2MembersSupplierPost$Params, context?: HttpContext): Observable<StrictHttpResponse<MembersWithoutSupplierData>> {
    return inviteSupplierApiV2MembersSupplierPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Invite Supplier.
   *
   * Invite a new supplier via email.
   *
   * This endpoint creates a new member document for a supplier invite,
   * initializes default attributes, and sends an invitation email asynchronously.
   *
   * Args:
   *     member_in (schemas.MembersCreateFromEmailInvite): The supplier invitation data.
   *     auth_token (Any): The authentication token containing the user's email.
   *     org (Any): Organization details for the secretariat member issuing the invite.
   *     background_tasks (BackgroundTasks): A background task handler for sending emails.
   *
   * Returns:
   *     schemas.MembersWithoutSupplierData: The created supplier member document without supplier-specific data.
   *
   * Raises:
   *     HTTPException: If the authenticated user is not a member of the organization.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inviteSupplierApiV2MembersSupplierPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inviteSupplierApiV2MembersSupplierPost(params: InviteSupplierApiV2MembersSupplierPost$Params, context?: HttpContext): Observable<MembersWithoutSupplierData> {
    return this.inviteSupplierApiV2MembersSupplierPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<MembersWithoutSupplierData>): MembersWithoutSupplierData => r.body)
    );
  }

  /** Path part for operation `inviteSuppliersApiV2MembersSuppliersPost()` */
  static readonly InviteSuppliersApiV2MembersSuppliersPostPath = '/api/v2/members/suppliers';

  /**
   * Invite Suppliers.
   *
   * Invite multiple new suppliers via email.
   *
   * This endpoint processes a list of supplier invitation data, creates new member records for suppliers
   * (if they do not already exist), and sends invitation emails asynchronously. It also returns details
   * on successfully invited suppliers, suppliers that already exist, and any failures.
   *
   * Args:
   *     member_in (list[schemas.MembersCreateFromEmailInvite]): A list of supplier invitation data.
   *     auth_token (Any): The authentication token containing the user's email.
   *     tenant (str): The secretariat identifier.
   *     org (Any): Organization details for the secretariat member issuing the invites.
   *     background_tasks (BackgroundTasks): A background task handler for sending emails.
   *
   * Returns:
   *     dict: A dictionary containing keys "success", "already_existing", and "failed" representing the outcome.
   *
   * Raises:
   *     HTTPException: If the authenticated user is not a member of the organization.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inviteSuppliersApiV2MembersSuppliersPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inviteSuppliersApiV2MembersSuppliersPost$Response(params: InviteSuppliersApiV2MembersSuppliersPost$Params, context?: HttpContext): Observable<StrictHttpResponse<MembersInviteSuppliers>> {
    return inviteSuppliersApiV2MembersSuppliersPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Invite Suppliers.
   *
   * Invite multiple new suppliers via email.
   *
   * This endpoint processes a list of supplier invitation data, creates new member records for suppliers
   * (if they do not already exist), and sends invitation emails asynchronously. It also returns details
   * on successfully invited suppliers, suppliers that already exist, and any failures.
   *
   * Args:
   *     member_in (list[schemas.MembersCreateFromEmailInvite]): A list of supplier invitation data.
   *     auth_token (Any): The authentication token containing the user's email.
   *     tenant (str): The secretariat identifier.
   *     org (Any): Organization details for the secretariat member issuing the invites.
   *     background_tasks (BackgroundTasks): A background task handler for sending emails.
   *
   * Returns:
   *     dict: A dictionary containing keys "success", "already_existing", and "failed" representing the outcome.
   *
   * Raises:
   *     HTTPException: If the authenticated user is not a member of the organization.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inviteSuppliersApiV2MembersSuppliersPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inviteSuppliersApiV2MembersSuppliersPost(params: InviteSuppliersApiV2MembersSuppliersPost$Params, context?: HttpContext): Observable<MembersInviteSuppliers> {
    return this.inviteSuppliersApiV2MembersSuppliersPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<MembersInviteSuppliers>): MembersInviteSuppliers => r.body)
    );
  }

  /** Path part for operation `broadcastSubmissionRemindersToSuppliersApiV2MembersSuppliersSubmissionsBroadcastPost()` */
  static readonly BroadcastSubmissionRemindersToSuppliersApiV2MembersSuppliersSubmissionsBroadcastPostPath = '/api/v2/members/suppliers/submissions/broadcast';

  /**
   * Broadcast Submission Reminders To Suppliers.
   *
   * Broadcast submission reminder emails to suppliers.
   *
   * This endpoint sends reminder emails to suppliers, prompting them to complete their submissions.
   * It accepts either a list of email addresses or a list of organization IDs. If org_ids are provided,
   * every active team member of each organization is reminded. The email is sent asynchronously via a background task.
   *
   * An org_id that can't be reached is skipped and the rest are still reminded. An org_id can't be
   * reached if it is not a supplier of the organization (for a secretariat, not one of its active
   * member companies), if it has been deleted, or if it has no active team member. Each skipped org
   * is returned with the reason and logged. One with no active team member is also reported to
   * Sentry.
   *
   * Args:
   *     broadcast_in (schemas.BroadcastReminder): The broadcast data including emails (or org_ids), subject, and body.
   *     org (Any): Organization details sending the broadcast.
   *     background_tasks (BackgroundTasks): A background task handler for sending emails.
   *     censor_data (bool, optional): Whether to censor the returned emails. Validated based on user role.
   *
   * Returns:
   *     dict: The status, the emails that were sent reminders, and the orgs that were skipped.
   *
   * Raises:
   *     HTTPException: If the authenticated user is not a member of the organization.
   *     HTTPException: 400 if nobody can be reminded because every org_id was skipped. The detail
   *         names each org and why.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `broadcastSubmissionRemindersToSuppliersApiV2MembersSuppliersSubmissionsBroadcastPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  broadcastSubmissionRemindersToSuppliersApiV2MembersSuppliersSubmissionsBroadcastPost$Response(params: BroadcastSubmissionRemindersToSuppliersApiV2MembersSuppliersSubmissionsBroadcastPost$Params, context?: HttpContext): Observable<StrictHttpResponse<BroadcastReminderEmailResponse>> {
    return broadcastSubmissionRemindersToSuppliersApiV2MembersSuppliersSubmissionsBroadcastPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Broadcast Submission Reminders To Suppliers.
   *
   * Broadcast submission reminder emails to suppliers.
   *
   * This endpoint sends reminder emails to suppliers, prompting them to complete their submissions.
   * It accepts either a list of email addresses or a list of organization IDs. If org_ids are provided,
   * every active team member of each organization is reminded. The email is sent asynchronously via a background task.
   *
   * An org_id that can't be reached is skipped and the rest are still reminded. An org_id can't be
   * reached if it is not a supplier of the organization (for a secretariat, not one of its active
   * member companies), if it has been deleted, or if it has no active team member. Each skipped org
   * is returned with the reason and logged. One with no active team member is also reported to
   * Sentry.
   *
   * Args:
   *     broadcast_in (schemas.BroadcastReminder): The broadcast data including emails (or org_ids), subject, and body.
   *     org (Any): Organization details sending the broadcast.
   *     background_tasks (BackgroundTasks): A background task handler for sending emails.
   *     censor_data (bool, optional): Whether to censor the returned emails. Validated based on user role.
   *
   * Returns:
   *     dict: The status, the emails that were sent reminders, and the orgs that were skipped.
   *
   * Raises:
   *     HTTPException: If the authenticated user is not a member of the organization.
   *     HTTPException: 400 if nobody can be reminded because every org_id was skipped. The detail
   *         names each org and why.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `broadcastSubmissionRemindersToSuppliersApiV2MembersSuppliersSubmissionsBroadcastPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  broadcastSubmissionRemindersToSuppliersApiV2MembersSuppliersSubmissionsBroadcastPost(params: BroadcastSubmissionRemindersToSuppliersApiV2MembersSuppliersSubmissionsBroadcastPost$Params, context?: HttpContext): Observable<BroadcastReminderEmailResponse> {
    return this.broadcastSubmissionRemindersToSuppliersApiV2MembersSuppliersSubmissionsBroadcastPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<BroadcastReminderEmailResponse>): BroadcastReminderEmailResponse => r.body)
    );
  }

  /** Path part for operation `updateUpstreamOrganizationApiV2MembersOrgIdProfilePatch()` */
  static readonly UpdateUpstreamOrganizationApiV2MembersOrgIdProfilePatchPath = '/api/v2/members/{orgId}/profile';

  /**
   * Update Upstream Organization.
   *
   * Update supplier organization profile from downstream member perspective.
   *
   * This endpoint enables member organizations to update their supplier's organizational
   * profile and primary contact information. It enforces strict supplier relationship
   * validation to ensure only authorized downstream members can modify their upstream
   * suppliers' data. When a new primary contact is specified, the system replaces the
   * existing primary contact and dispatches welcome notifications to the new contact person.
   *
   * Args:
   *     org_id (str): Target supplier organization identifier to be updated.
   *     org (Any): Requesting member organization with supplier management privileges.
   *     tenant (str): Secretariat tenant scope for the operation.
   *     member_in (schemas.MembersUpdateByDownstream): Supplier update payload from
   *         downstream member perspective.
   *     background_tasks (BackgroundTasks): Asynchronous task queue for email dispatch.
   *
   * Returns:
   *     schemas.MembersWithTeamValidation: Updated supplier organization record
   *         excluding nested supplier relationship data.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateUpstreamOrganizationApiV2MembersOrgIdProfilePatch()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUpstreamOrganizationApiV2MembersOrgIdProfilePatch$Response(params: UpdateUpstreamOrganizationApiV2MembersOrgIdProfilePatch$Params, context?: HttpContext): Observable<StrictHttpResponse<MembersWithTeamValidation>> {
    return updateUpstreamOrganizationApiV2MembersOrgIdProfilePatch(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Upstream Organization.
   *
   * Update supplier organization profile from downstream member perspective.
   *
   * This endpoint enables member organizations to update their supplier's organizational
   * profile and primary contact information. It enforces strict supplier relationship
   * validation to ensure only authorized downstream members can modify their upstream
   * suppliers' data. When a new primary contact is specified, the system replaces the
   * existing primary contact and dispatches welcome notifications to the new contact person.
   *
   * Args:
   *     org_id (str): Target supplier organization identifier to be updated.
   *     org (Any): Requesting member organization with supplier management privileges.
   *     tenant (str): Secretariat tenant scope for the operation.
   *     member_in (schemas.MembersUpdateByDownstream): Supplier update payload from
   *         downstream member perspective.
   *     background_tasks (BackgroundTasks): Asynchronous task queue for email dispatch.
   *
   * Returns:
   *     schemas.MembersWithTeamValidation: Updated supplier organization record
   *         excluding nested supplier relationship data.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateUpstreamOrganizationApiV2MembersOrgIdProfilePatch$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUpstreamOrganizationApiV2MembersOrgIdProfilePatch(params: UpdateUpstreamOrganizationApiV2MembersOrgIdProfilePatch$Params, context?: HttpContext): Observable<MembersWithTeamValidation> {
    return this.updateUpstreamOrganizationApiV2MembersOrgIdProfilePatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<MembersWithTeamValidation>): MembersWithTeamValidation => r.body)
    );
  }

  /** Path part for operation `removeOrganizationApiV2MembersOrgIdDelete()` */
  static readonly RemoveOrganizationApiV2MembersOrgIdDeletePath = '/api/v2/members/{orgId}';

  /**
   * Remove Organization.
   *
   * Delete an organization by marking it as deleted.
   *
   * This endpoint performs a soft delete on an organization by updating its status to 'deleted'
   * and recording deletion metadata. Only Agridence admin users can perform this operation.
   * The organization record is preserved but marked as deleted for audit purposes.
   *
   * Args:
   *     org (Any): Organization details for permission validation. Must be an Agridence admin organization.
   *     org_id (str): Organization ID of the member organization to soft delete.
   *     auth_token (dict): Authentication token containing the user's email for audit trail.
   *
   * Raises:
   *     HTTPException: 400 if the target organization does not exist.
   *     HTTPException: 403 if the requesting organization is not an Agridence admin.
   *
   * Returns:
   *     schemas.MembersWithoutSupplierData: The updated organization record with deleted status.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeOrganizationApiV2MembersOrgIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeOrganizationApiV2MembersOrgIdDelete$Response(params: RemoveOrganizationApiV2MembersOrgIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<MembersWithoutSupplierData>> {
    return removeOrganizationApiV2MembersOrgIdDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Remove Organization.
   *
   * Delete an organization by marking it as deleted.
   *
   * This endpoint performs a soft delete on an organization by updating its status to 'deleted'
   * and recording deletion metadata. Only Agridence admin users can perform this operation.
   * The organization record is preserved but marked as deleted for audit purposes.
   *
   * Args:
   *     org (Any): Organization details for permission validation. Must be an Agridence admin organization.
   *     org_id (str): Organization ID of the member organization to soft delete.
   *     auth_token (dict): Authentication token containing the user's email for audit trail.
   *
   * Raises:
   *     HTTPException: 400 if the target organization does not exist.
   *     HTTPException: 403 if the requesting organization is not an Agridence admin.
   *
   * Returns:
   *     schemas.MembersWithoutSupplierData: The updated organization record with deleted status.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeOrganizationApiV2MembersOrgIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeOrganizationApiV2MembersOrgIdDelete(params: RemoveOrganizationApiV2MembersOrgIdDelete$Params, context?: HttpContext): Observable<MembersWithoutSupplierData> {
    return this.removeOrganizationApiV2MembersOrgIdDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<MembersWithoutSupplierData>): MembersWithoutSupplierData => r.body)
    );
  }

  /** Path part for operation `sendOrganizationWelcomeEmailsApiV2MembersOrgsEmailsPost()` */
  static readonly SendOrganizationWelcomeEmailsApiV2MembersOrgsEmailsPostPath = '/api/v2/members/orgs/emails';

  /**
   * Send Organization Welcome Emails.
   *
   * Send welcome emails to organization members.
   *
   * This endpoint sends welcome emails to organization members asynchronously via background tasks.
   * It accepts a list of member data (name and email) and dispatches welcome emails to each recipient.
   * Only Agridence admin users can use this endpoint.
   *
   * Args:
   *     orgs_input (list[schemas.MembersSendEmailSchema]): List of member data containing
   *         organization names and email addresses for welcome email recipients.
   *     tenant (str): The tenant/secretariat identifier used in email templates.
   *     org (Any): Organization details for permission validation. Must be an Agridence admin organization.
   *     background_tasks (BackgroundTasks): Background task handler for asynchronous email dispatch.
   *
   * Returns:
   *     schemas.MembersSendEmailResponseSchema: Response containing email count and recipient list.
   *
   * Raises:
   *     HTTPException: 403 if the requesting organization is not an Agridence admin.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendOrganizationWelcomeEmailsApiV2MembersOrgsEmailsPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendOrganizationWelcomeEmailsApiV2MembersOrgsEmailsPost$Response(params: SendOrganizationWelcomeEmailsApiV2MembersOrgsEmailsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<MembersSendEmailResponseSchema>> {
    return sendOrganizationWelcomeEmailsApiV2MembersOrgsEmailsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Send Organization Welcome Emails.
   *
   * Send welcome emails to organization members.
   *
   * This endpoint sends welcome emails to organization members asynchronously via background tasks.
   * It accepts a list of member data (name and email) and dispatches welcome emails to each recipient.
   * Only Agridence admin users can use this endpoint.
   *
   * Args:
   *     orgs_input (list[schemas.MembersSendEmailSchema]): List of member data containing
   *         organization names and email addresses for welcome email recipients.
   *     tenant (str): The tenant/secretariat identifier used in email templates.
   *     org (Any): Organization details for permission validation. Must be an Agridence admin organization.
   *     background_tasks (BackgroundTasks): Background task handler for asynchronous email dispatch.
   *
   * Returns:
   *     schemas.MembersSendEmailResponseSchema: Response containing email count and recipient list.
   *
   * Raises:
   *     HTTPException: 403 if the requesting organization is not an Agridence admin.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sendOrganizationWelcomeEmailsApiV2MembersOrgsEmailsPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendOrganizationWelcomeEmailsApiV2MembersOrgsEmailsPost(params: SendOrganizationWelcomeEmailsApiV2MembersOrgsEmailsPost$Params, context?: HttpContext): Observable<MembersSendEmailResponseSchema> {
    return this.sendOrganizationWelcomeEmailsApiV2MembersOrgsEmailsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<MembersSendEmailResponseSchema>): MembersSendEmailResponseSchema => r.body)
    );
  }

}
